import { useSharedDataPrivacyApi } from '@/features/api/hooks/shared-data-privacy/useSharedDataPrivacyApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useCollectUserDataAndSendMail = () => {
  const api = useSharedDataPrivacyApi();

  return useApiMutation<void, unknown, void>({
    mutationFn: () => api.collectUserDataAndSendMail()
  });
};
